export default "__VITE_ASSET__qt5MVL7v__"